import React from 'react';
import NavDrawer from "../../../ui/nav/NavDrawer";
import NavAppBar from "../../../ui/nav/NavAppBar";

const NavSection = () => {
    const [mobileOpen, setMobileOpen] = React.useState<boolean>(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    return (
        <React.Fragment>
            <NavAppBar toggle={handleDrawerToggle} />
            <NavDrawer open={mobileOpen} toggle={handleDrawerToggle} />
        </React.Fragment>
    );
};

export default NavSection;
